import bridge from '@vkontakte/vk-bridge';
import { DebugScreen } from '../../components';
export function initDebugScreen(rootEl) {
    var debugScreen = new DebugScreen({
        onClickBtn1: function () {
            debugScreen.log('onClickBtn1');
            if (FOR_VK) {
                bridge
                    // @ts-ignore
                    .send('VKWebAppCheckNativeAds', { ad_format: 'reward', use_waterfall: true })
                    .then(function (data) {
                    debugScreen.log('check then:', data);
                })
                    .catch(function (error) {
                    debugScreen.log('check catch:', error);
                });
            }
        },
        onClickBtn2: function () {
            debugScreen.log('onClickBtn2');
            if (FOR_VK) {
                bridge
                    // @ts-ignore
                    .send('VKWebAppShowNativeAds', { ad_format: 'reward', use_waterfall: true })
                    .then(function (data) {
                    debugScreen.log('show then:', data);
                })
                    .catch(function (error) {
                    debugScreen.log('show catch:', error);
                });
            }
        },
    });
    debugScreen.mount(rootEl);
    if (DEVELOPMENT && location.search.includes('debug')) {
        setTimeout(function () { return debugScreen.show(); }, 100);
    }
    // if (FOR_VK && isDebugMode()) {
    //   bridge.subscribe((e) => {
    //     debugScreen.log(e)
    //     console.log(e)
    //   })
    // }
    return debugScreen;
}
